import EdgateCorrelations from './EdgateCorrelations';

export default EdgateCorrelations;
